'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _common = require('../common');

var _WMTableHeader = require('../WMTableHeader');

var _WMTableHeader2 = _interopRequireDefault(_WMTableHeader);

var _WMTableHeaderCell = require('../WMTableHeaderCell');

var _WMTableHeaderCell2 = _interopRequireDefault(_WMTableHeaderCell);

var _WMTableBody = require('../WMTableBody');

var _WMTableBody2 = _interopRequireDefault(_WMTableBody);

var _WMTableRow = require('../WMTableRow');

var _WMTableRow2 = _interopRequireDefault(_WMTableRow);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	children: _propTypes2.default.node.isRequired,
	hideDisabledCheckboxes: _propTypes2.default.bool,
	selectable: _propTypes2.default.bool,
	maxHeight: _propTypes2.default.string,
	hover: _propTypes2.default.bool,
	striped: _propTypes2.default.bool
};

var WMTable = function WMTable(props) {
	var arrHeaderChildren = void 0;
	var tableHeader = void 0;
	var tableBody = void 0;

	var myChildren = (0, _common.Arrayify)(props.children).filter(function (child) {
		return child;
	});

	myChildren.forEach(function (child) {
		if (child.type === _WMTableHeader2.default) {
			if (!tableHeader) {
				tableHeader = child;
			} else {
				throw new Error('WMTable must contain only 1 WMTableHeader.');
			}
		}

		if (child.type === _WMTableBody2.default) {
			if (!tableBody) {
				tableBody = child;
			} else {
				throw new Error('WMTable must contain only 1 WMTableBody.');
			}
		}
	});

	if (!tableHeader) {
		throw new Error('WMTable must contain a WMTableHeader.');
	} else if (tableHeader.props.children) {
		var headerChildren = tableHeader.props.children;

		arrHeaderChildren = (_immutable.Iterable.isIterable(headerChildren) ? headerChildren.toArray() : (0, _common.Arrayify)(headerChildren)).filter(function (child) {
			if (child && child.type !== _WMTableHeaderCell2.default) {
				throw new Error('WMTableHeader must only contain WMTableHeaderCell(s).');
			}

			return child && child.type === _WMTableHeaderCell2.default;
		});
	} else {
		throw new Error('WMTable must contain a WMTableHeader with WMTableHeaderCell(s).');
	}

	if (!tableBody) {
		throw new Error('WMTable must contain a WMTableBody.');
	} else if (tableBody.props.children) {
		var bodyChildren = tableBody.props.children;
		var arrBodyChildren = _immutable.Iterable.isIterable(bodyChildren) ? bodyChildren.toArray() : (0, _common.Arrayify)(bodyChildren);

		arrBodyChildren.forEach(function (child) {
			if (child && child.type !== _WMTableRow2.default) {
				throw new Error('WMTableBody must only contain WMTableRow(s).');
			}

			return child && child.type === _WMTableRow2.default;
		});
	}

	return _react2.default.createElement(
		'div',
		{
			'data-component-identifier': 'wm-table-container',
			style: _styles2.default.table.maxHeight(props.maxHeight)
		},
		_react2.default.createElement(
			'div',
			{
				'data-component-identifier': 'wm-table',
				style: _styles2.default.table
			},
			myChildren.map(function (element, index) {
				var additionalProps = { key: index };

				if (props.hover) additionalProps.hover = props.hover;
				if (props.striped) additionalProps.striped = props.striped;
				if (props.selectable) additionalProps.selectable = props.selectable;
				if (props.hideDisabledCheckboxes) {
					additionalProps.hideDisabledCheckboxes = props.hideDisabledCheckboxes;
				}

				var computedProps = Object.assign({}, element.props, additionalProps);

				if (element.type === _WMTableBody2.default) {
					computedProps.columnAlignment = arrHeaderChildren.map(function (column) {
						return column.props.right;
					});
				}

				return _react2.default.createElement(element.type, computedProps);
			})
		)
	);
};

exports.default = (0, _radium2.default)(WMTable);


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTable/index.js